// v1 (legacy) of the view-members family. Uses lowercase `userID` / `userNameFull` /
// `groupID` / `groupMembers` data shapes from the OLD Triyo.MVC backend. The MVC chain
// that ran through `<PlusIconPanel>` was killed in TAD-5150 — this component now uses
// `<PlusIconPanelNew>`, which calls the NEW `EditProjectMembers` endpoint and
// self-fetches its users/groups list via the NEW Triyo.API. All 5 active consumers
// (tasks-by-report-table-row, taskTableRow, PopupBody, GroupRowNew,
// custom-project-filter-dropdown-toggle) are display-only — none currently pass the
// `projects` prop, so the Plus-Icon-Panel-New render path is unreachable from this
// wrapper at runtime. The path remains correctly wired for future use.
//
// This component, `view-members-new.jsx` (v2), and `view-members-projects.jsx` (v3) are
// three generations of the same "show member icons + popover + optional Plus button"
// concept. Consolidating them into a single component is a separate architectural
// cleanup, deliberately out of scope for the Triyo.MVC removal effort.
import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import Dropdown from "react-bootstrap/Dropdown";
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import MemberIcon from "../member-icon/member-icon";
import MemberDropdown from "../member-dropdown/member-dropdown";
import PlusIconPanel from "../plus-icon/Plus-Icon-Panel-New";
import PlusIcon from "../plus-icon/Plus-Icon";
import "./view-members.scss";

const ViewMembersPanel = ({
  members,
  UserID,
  taskType,
  projects,
  onEdit,
  isGroup,
  textChange = false,
  memberAddDisabled
}) => {
  const membersArray = members ?? [];
  const memberLength = membersArray.length > 0 ? membersArray.length : 0;
  
  const [user, setUser] = useState({}); //stores the owner object
  const [extraMembers, setExtraMembers] = useState(memberLength - 3); //amount of extraMembers
  const [ownerShown, setOwnerShown] = useState(false);

  //for projects implementation
  const [plusPosition, setPlusPosition] = useState(0);
  const [nameClass, setNameClass] = useState("");
  const [showPlusPanel, setShowPlusPanel] = useState(false);
  const [membersCount, setMembersCount] = useState(0);
  const [showDropdown, setShowDropdown] = useState(false);
  const [isMembersTooltipVisible, setIsMembersTooltipVisible] = useState(false);  
  const [menuWidth, setMenuWidth] = useState(0);

  // Default user
  const [MembersShown, setMembersShown] = useState([
    {
      approve: false,
      assign: false,
      createdDate: "0001-01-01T00:00:00",
      isActive: false,
      publish: false,
      userID: 0,
      userName: "Z",
      userNameFull: "Z Z",
      view: false,
    },
  ]);

  const [MembersOnPanel, setMembersOnPanel] = useState([
    {
      approve: false,
      assign: false,
      createdDate: "0001-01-01T00:00:00",
      isActive: false,
      publish: false,
      userID: 0,
      userName: "Z",
      userNameFull: "Z Z",
      view: false,
    },
  ]);

  //array that stores the classNames of all the icon positions
  const [position, setNewPosition] = useState([
    "first-icon",
    "second-icon",
    "third-icon",
    "fourth-icon",
    "fifth-icon"
  ]);

  const FindClassName = (length) => {
    if (length <= 3) {
      return "show-member-panel"
    } else if (projects) {
      return "show-member-panel-projects"
    } else if (length === 4) {
      return "show-member-panel-tasks-1"
    } else {
      return "show-member-panel-tasks"
    }
  }

  const initialFunction = () => {
    //FINDS OWNER, SORTS MEMBERS IN ALPHABETICAL ORDER WITH OWNER AS FIRST ELEMENT
    const newUser = membersArray.find((element) => element.userID === UserID);
    let newMembersList = [];
    let newMembersShown = [];
    let count = 0;

    if (newUser) {
      setUser(newUser);
      newMembersList = membersArray.filter((member) => {
        return member?.userID != UserID;
      });
      setOwnerShown(true);
    } else {
      newMembersList = memberLength > 0 ? membersArray : [];
      setOwnerShown(false);
    }

    newMembersShown = newMembersList.sort(function compare(a, b) {
      let name1 = a.userNameFull.split(" ");
      let name2 = b.userNameFull.split(" ");
      if (name1[0] < name2[0]) return -1;
      if (name1[0] > name2[0]) return 1;
      if (name1[0] === name2[0]) {
        if (name1[1] < name2[1]) return -1;
        if (name1[1] > name2[1]) return 1;
      }
    });

    if (newUser) {
      newMembersShown.unshift(newUser);
    }
    if (projects) {
      setNameClass("-projects");
      //setMembersLength based off of length of MembersShown
      if (newMembersShown.length >= 4) {
        setPlusPosition(4);
      } else {
        setPlusPosition(newMembersShown.length);
      }
      setMembersShown(newMembersShown);

      //ADDING THE GROUP MEMBERS TO BE SHOWN ON THE MEMBERS PANEL
      let updatedMembersShown = [];
      //THIS WILL ADD GROUP MEMBERS TO THE LIST IN VIEW MEMBERS PANEL, BUT NOT IN THE ICONS
      for (let i = 0; i < newMembersShown.length; i++) {
        if ((typeof(newMembersShown[i].groupMembers) !== 'undefined') && (newMembersShown[i].groupMembers !== null) ){

          count += newMembersShown[i].groupMembers.length;

        } 
        else {count++}
      
       updatedMembersShown.push(newMembersShown[i])
      
      }
      setMembersOnPanel(updatedMembersShown)
      setMembersCount(count);

    } else {

      setMembersOnPanel(newMembersShown);
      setMembersShown(newMembersShown);
    }
  }

  const closePlusPanel = () => {
    setShowPlusPanel(false);
  };

  const getClickPosition = (e) => { 
    var xPosition = 40;
    let windowWidth =document.documentElement.offsetWidth;
    if(e.clientX + 475 > windowWidth)
      xPosition= -410;
    setMenuWidth(xPosition);   
  }

  useEffect(() => {
    initialFunction();
    setExtraMembers(membersArray.length - 3);
  }, [members]);

  return (
    <div>
      <Dropdown drop={"down"} className="removeArrow" onMouseLeave={() => setShowDropdown(false)}
      onMouseOver={() => setShowDropdown(true)} 
      onClick={(e) => 
        e.nativeEvent.stopImmediatePropagation()
      }
      >
        <Dropdown.Toggle
          as={"div"}
          className={`member-dropdown-toggle${nameClass}`}
          onClick={(e) => 
            e.nativeEvent.stopImmediatePropagation()
          }
        >
          {
            <div>
              {
                //loops through Members for each icon
                MembersShown &&
                  MembersShown.slice(0, 4).map((entry, index) => (
                    <div key={index} className={`${position[index]}`}>
                      {index === 0 && ownerShown ? (
                        <MemberIcon member={entry} type={"user"}></MemberIcon>
                      ) : index === 3 && extraMembers > 0 ? (
                        <MemberIcon
                          member={entry}
                          extraMembers={extraMembers}
                          type={"extra"}
                        ></MemberIcon>
                      ) : (
                        <MemberIcon
                          member={entry}
                          type={"default"}
                        ></MemberIcon>
                      )}
                    </div>
                  ))
              }
            </div>
          }
        </Dropdown.Toggle>
        
        {/* <Dropdown.Menu show={showDropdown} className={`${(members.length <= 3) ? 'show-member-panel' : projects? 'show-member-panel-projects' : (members.length === 4) ? 'show-member-panel-tasks-1' : 'show-member-panel-tasks'} `} > */}        
        <Dropdown.Menu
          show={showDropdown}
          style={{ 'width': `${projects? '320px' : '272px'}` }}
          className={FindClassName(memberLength)}
          drop-dropup-auto="false"
        >
          <div className={"member-dropdown-row-header"}>
            <div className={"member-dropdown-title-text"}>
              {
                textChange ? "Actionable by" : "View Members/Groups" 
              }             
            </div>           

          </div>
          <Dropdown.Divider style={{ 'width': `${projects? '320px' : '272px'}` }}></Dropdown.Divider>

          <div className={"member-dropdown-body-wrapper"}>
            {MembersOnPanel &&
              MembersOnPanel.map((entry, index) =>
                index === 0 && ownerShown ? (
                  <div key={index}>
                    <MemberDropdown
                      member={isGroup? {...entry, groupID: null} : entry}
                      taskType={taskType}
                      type={"user"}
                      filter={false}
                      toggleRow={() => {}}
                      selectedMembers={[]}
                      projects={projects}
                    ></MemberDropdown>
                  </div>
                ) : (
                  <div key={index}>
                    <Dropdown.Divider style={{ 'width': `${projects? '290px' : '240px'}`, 'marginLeft': '15px' }} />
                    <MemberDropdown
                      member={isGroup? {...entry, groupID: null} : entry}
                      taskType={taskType}
                      type={""}
                      filter={false}
                      toggleRow={() => {}}
                      selectedMembers={[]}
                      projects={projects}
                    />
                  </div>
                )
              )}
          </div>
        </Dropdown.Menu>
        
      </Dropdown>
      {projects ? (
        <div className={`member-plus`} onClick={e => getClickPosition(e)}>
          <div className={`member-dropdown-toggle-plus`}>
            {
              memberAddDisabled ? 
              <>
              <OverlayTrigger
                placement="bottom-end"
                overlay={
                  <Tooltip>
                      You don't have access to edit projects. Please contact administration for assistance.
                  </Tooltip>
                }
              > 
              <div className={`${position[plusPosition]}`}>
            
                <PlusIcon func={() => setShowPlusPanel(true)} active={showPlusPanel} disabled={memberAddDisabled} projectId={projects?.id}></PlusIcon>
                {showPlusPanel ? (
                  <PlusIconPanel
                    userID={UserID}
                    projects={projects}
                    onEdit={onEdit}
                    selectedMembers={[...MembersShown]}
                    close={closePlusPanel}
                    menuWidth={menuWidth}
                  />
                ) : (
                  <></>
                )}
              </div>
              </OverlayTrigger> 
              </>
              :
              <div className={`${position[plusPosition]}`}  id={"plusIconFixed_" + projects?.id}>
                <OverlayTrigger
                  placement="bottom"
                  show={isMembersTooltipVisible && !showPlusPanel}
                  trigger={['hover','hover']}
                  onToggle={(toggle) => {
                      setIsMembersTooltipVisible(toggle)
                  }}
                  overlay={<Tooltip>Add Member</Tooltip>}>
                      <div>
                          <PlusIcon 
                              className="bg-dark" 
                              func={() => {
                                  console.log({showPlusPanel, isMembersTooltipVisible})
                                  setShowPlusPanel(true)
                              }} 
                              active={showPlusPanel}
                              disabled={memberAddDisabled}
                              projectId={projects?.id}
                              >
                          </PlusIcon>
                      </div>
                </OverlayTrigger>
                {showPlusPanel ? (
                  <PlusIconPanel
                    userID={UserID}
                    projects={projects}
                    onEdit={onEdit}
                    selectedMembers={[...MembersShown]}
                    close={closePlusPanel}
                    menuWidth={menuWidth}
                  />
                ) : (
                  <></>
                )}
              </div>
            }    
          </div>
        </div>
      ) : (
        <></>
      )}
    </div>
  );
};

ViewMembersPanel.propTypes = {
  members: PropTypes.array,
  UserID: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  taskType: PropTypes.string,
  projects: PropTypes.object,
  onEdit: PropTypes.func,
  isGroup: PropTypes.bool,
  textChange: PropTypes.bool,
  memberAddDisabled: PropTypes.bool,
};

ViewMembersPanel.defaultProps = {
  members: [],
  textChange: false,
  memberAddDisabled: false,
};

export default ViewMembersPanel;
